import { apiJson } from '@/lib/api';

export const OUTREACH_REPLY_ACCEPT =
  '.pdf,.png,.jpg,.jpeg,.gif,.webp,.txt,.csv,.doc,.docx';

export const OUTREACH_REPLY_MAX_FILES = 5;

export type OutreachReplySendPayload = {
  subject: string;
  body: string;
  include_quoted_original: boolean;
  files: File[];
};

export function appendOutreachReplyAttachments(
  form: FormData,
  files: File[],
): void {
  for (const file of files) {
    form.append('attachments', file);
  }
}

export function buildOutreachReplyFormData(
  payload: OutreachReplySendPayload,
): FormData {
  const form = new FormData();
  form.append('subject', payload.subject);
  form.append('body', payload.body);
  form.append(
    'include_quoted_original',
    payload.include_quoted_original ? 'true' : 'false',
  );
  appendOutreachReplyAttachments(form, payload.files);
  return form;
}

export function buildResendTestFormData(
  email: string,
  files: File[],
): FormData {
  const form = new FormData();
  form.append('email', email);
  appendOutreachReplyAttachments(form, files);
  return form;
}

export function sendOutreachReply<T>(
  getToken: () => Promise<string | null>,
  path: string,
  payload: OutreachReplySendPayload,
): Promise<T> {
  return apiJson<T>(getToken, path, {
    method: 'POST',
    body: buildOutreachReplyFormData(payload),
  });
}
